import { render, staticRenderFns } from "./EditViewTermReportsSubjectRecords.vue?vue&type=template&id=058d92a0"
import script from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js"
export * from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js"
import style0 from "./EditViewTermReportsSubjectRecords.vue?vue&type=style&index=0&id=058d92a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports